// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"d4d7c659","605":"3b38a7d2","753":"17c21a8d","981":"7b07611e"}[chunkId] + ".chunk.js";
};